import NewWrapper from '@/components/BodyLayout/NewWrapper';
import IpfsHashList from '@/components/IpfsHashList/IpfsHashList';

const ipfs = () => {
  return (
    <NewWrapper>
      <IpfsHashList />
    </NewWrapper>
  );
};

export default ipfs;
